import { CnPrintBtn } from 'src/components/cn-print-btn';
export default CnPrintBtn;
